import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Printer } from 'react-feather'

import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableMovements = ({ useFetchInit }) => {

    const { FetchData, Helpers, Actions } = useFetchInit

    const { fetchBankMovements } = FetchData
    const { dataBankMovements, loadingFetchBankMovements } = fetchBankMovements

    const { formatMoney } = Helpers
    const { handleClickShowMovement, handleClickPrintMovementReceipt } = Actions

    // Mismo orden que /cajas/transacciones (Info, Caja->Banco, Fecha, ID, Usuario, Tipo, Q, $, ..., Observaciones, Opciones)
    // con los campos propios de bancos (boleta y referencia ACH) antes de las observaciones
    const columnConfig = [
        {
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({ display: 'flex', alignItems: 'center', justifyContent: 'center' }),
            cellRenderer: (params) => {
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: 'banco', headerName: 'BANCO', minWidth: 250, filter: true },
        { field: 'movimiento_fecha', headerName: 'FECHA', minWidth: 150, filter: true },
        { field: 'idmovimiento', headerName: 'ID', minWidth: 100, filter: true },
        { field: 'movimiento_usuario', headerName: 'USUARIO', minWidth: 150, filter: true },
        { field: 'movimiento_tipo', headerName: 'TIPO', minWidth: 100, filter: true },
        {
            field: 'movimiento_quetzales',
            headerName: 'T. QUETZALES',
            minWidth: 150,
            filter: true,
            valueFormatter: (params) => `Q. ${formatMoney(params.value)}`
        },
        {
            field: 'movimiento_dolares',
            headerName: 'T. DOLARES',
            minWidth: 150,
            filter: true,
            valueFormatter: (params) => `$ ${formatMoney(params.value)}`
        },
        {
            field: 'boleta_numero',
            headerName: 'BOLETA #',
            minWidth: 150,
            filter: true,
            valueFormatter: (params) => params.value || '--'
        },
        {
            field: 'aprobacion_referencia_ach',
            headerName: 'REF. ACH',
            minWidth: 150,
            filter: true,
            valueFormatter: (params) => params.value || '--'
        },
        { field: 'movimiento_observaciones', headerName: 'OBSERVACIONES', minWidth: 400, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 200,
            cellRenderer: (params) => (
                <CustomDropDown>
                    <MenuItem onClick={() => handleClickShowMovement(params.data)}>
                        <ListItemIcon> <Edit2 color="black" /> </ListItemIcon>
                        <ListItemText primary="Informacion" />
                    </MenuItem>
                    <MenuItem onClick={() => handleClickPrintMovementReceipt(params.data)}>
                        <ListItemIcon> <Printer color="black" /> </ListItemIcon>
                        <ListItemText primary="Imprimir comprobante" />
                    </MenuItem>
                </CustomDropDown>
            )
        }
    ]

    return (
        <div className='content'>
            {loadingFetchBankMovements && (<LinearLoading />)}
            <CustomTableData
                rowConfig={dataBankMovements}
                columnConfig={columnConfig}
            />
        </div>
    )
}
